export default function FeaturedMusic() {
  const platforms = [
    { name: 'Spotify', icon: 'ri-spotify-fill', color: '#1DB954', url: 'https://open.spotify.com/album/3tQlTj8YpmywEmwRFxM0G1' },
    { name: 'YouTube', icon: 'ri-youtube-fill', color: '#FF0000', url: 'https://music.youtube.com/watch?v=aVQLciOCx8E&si=Yd-aRmgi1XyBeX-R' },
    { name: 'Apple Music', icon: 'ri-music-fill', color: '#FA243C', url: 'https://music.apple.com/us/song/welcome-to-the-republic/1866385563' },
  ];

  return (
    <section id="featured-music" className="relative py-32 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Album Artwork */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative group">
              <div className="absolute inset-0 border border-[#ff0033] rounded-lg pulse-border"></div>
              <div className="relative w-full max-w-[620px] aspect-square overflow-hidden rounded-lg">
                <img
                  src="https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/7396cdc3f1f91a79aa81afe08ed12fd8.jpeg"
                  alt="Latest Album"
                  className="w-full h-full object-cover transition-all duration-600 group-hover:scale-102"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <p className="text-[11px] tracking-widest text-[#4dd0e1] font-semibold uppercase">
              Latest Release
            </p>
            <h2 className="text-5xl md:text-6xl font-bold text-white font-serif leading-tight">
              Welcome to the "Republic"
            </h2>
            <p className="text-sm text-gray-400">Released January 2026</p>
            <p className="text-base md:text-lg text-gray-300 leading-relaxed max-w-xl">
              A haunting journey through a dystopian future filled with digital ID, tracking every movement and purchase you make for the "greater good". They want you to believe it won't happen and that we live in a free country.
            </p>

            {/* Streaming Platforms */}
            <div className="pt-4">
              <p className="text-xs tracking-wider text-gray-400 mb-4 uppercase">Stream On</p>
              <div className="flex gap-4 mb-8">
                {platforms.map((platform) => (
                  <a
                    key={platform.name}
                    href={platform.url}
                    className="w-14 h-14 rounded-full bg-[#1a1a1a] flex items-center justify-center hover:-translate-y-1.5 transition-all duration-300 group"
                    style={{
                      boxShadow: '0 0 0 rgba(0,0,0,0)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = `0 8px 20px ${platform.color}40`;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 0 0 rgba(0,0,0,0)';
                    }}
                    aria-label={platform.name}
                  >
                    <i className={`${platform.icon} text-2xl`} style={{ color: platform.color }}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}